<template>
  <div id="app">
    <router-view v-if="isLoginPage || isFullscreenPage" />
    <el-container v-else class="layout">
      <el-aside width="220px" class="aside">
        <AppSidebar />
      </el-aside>
      <el-container class="content-layout" direction="vertical">
        <AppHeader />
        <el-main class="main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AppSidebar from './components/AppSidebar.vue'
import AppHeader from './components/AppHeader.vue'
import { bindTipSoundUnlock } from '@/utils/tipSound'

export default {
  name: 'App',
  components: {
    AppSidebar,
    AppHeader
  },
  mounted() {
    // 首次用户交互后解锁提示音，避免浏览器拦截自动播放
    bindTipSoundUnlock()
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    },
    isFullscreenPage() {
      return !!(this.$route.meta && this.$route.meta.fullscreen)
    }
  }
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  background: #f5f7fa;
}

.layout {
  height: 100vh;
}

.aside {
  overflow: hidden;
  background: #fff;
}

.content-layout {
  min-width: 0;
  height: 100%;
}

.main {
  padding: 20px;
  overflow: auto;
  background: #f5f7fa;
}
</style>
